import { useT } from "../../i18n";
import Layout from "../../components/Layout";
import { Paper, Typography } from "@mui/material";
import MyAbwesenheitDataTable from "../../components/abwesenheiten/MyAbwesenheitDataTable";
import ErrorAlert from "../../components/ErrorAlert";
import { notPermitted } from "../../errors";
import React from "react";
import Guard from "../../components/Guard";

export default function MeineAbwesenheiten() {
  const { t } = useT("taetigkeitsbericht");
  const limit = parseInt(localStorage.getItem("meinUrlaubLimit") ?? "25", 10);
  return (
    <Layout title="Meine Abwesenheiten" showTitleInNav={false}>
      <Guard
        permission={"meine:abwesenheit:list"}
        fallback={<ErrorAlert error={notPermitted()} />}
      >
        <Paper
          elevation={1}
          sx={{ marginTop: 2, padding: 3, marginLeft: 2, marginRight: 2 }}
        >
          <Typography variant="h5">Meine Abwesenheiten</Typography>
          <MyAbwesenheitDataTable limit={limit} />
        </Paper>
      </Guard>
    </Layout>
  );
}
